import { Spacer } from "../../../components";
import useWindowSize from "../../../hooks/useWindowSize";
import { getStaticImg } from "../../../utils/function";
import analytics from "../../../utils/analytics";
import {
  CategoryDetailBtn,
  CategorySpacing,
  CategoryTitle,
  ContainerSchool,
  ContainerWidth,
  HallOfFameContainer,
  HallOfFameTitle,
  OnGoingTag,
  PlayerContainer,
  PlayerImg,
  PlayerWrapper,
  SectionContainer,
  TagPlayer,
} from "./HomeDetails.styled";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useFetchEventDetail,
  useFetchEventHallOfFame,
} from "../../../networks";
import moment from "moment";
const FUTSAL_SMA = "Futsal SMA";
const FUTSAL_SMP = "Futsal SMP";
// Key-nya "Futsal Kampus" sesuai respons event/hall-of-fame, bukan "Futsal Kuliah".
const FUTSAL_KAMPUS = "Futsal Kampus";
const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;

const HallOfFameCard = ({
  slug,
  soc = false,
  paddingContainerClassname,
  regionId,
}) => {
  const navigate = useNavigate();
  const { size } = useWindowSize();
  const currentYear = new Date()?.getFullYear();
  const { search } = useLocation();
  const urlParams = new URLSearchParams(search);
  const yearParam = urlParams.get("year");
  const isSOCPath = window.location.pathname.includes("/soc");
  const shouldUseSOC2025 = isSOCPath && (yearParam === "2025" || !yearParam);
  const socSlug = currentYear === 2025 ? "soc-2025" : "soc";

  const citySlug = !!soc ? socSlug : slug;

  const { data } = useFetchEventHallOfFame(citySlug);
  const { data: dataEventDetail } = useFetchEventDetail(slug);
  const dataEvent = dataEventDetail?.data?.data?.eventDetail ?? {};
  const hallOfFameData = data?.data?.data ?? {};

  const isMobileView = (size?.width || 0) <= 768;

  const getOrder = () => {
    const futsalSMA = hallOfFameData[FUTSAL_SMA];
    const futsalSMP = hallOfFameData[FUTSAL_SMP];
    let dataFutsalSMAAnchor = [
      futsalSMA?.["Best Coach"]?.[0],
      futsalSMA?.["MVP"]?.[0],
      futsalSMA?.["Top Scorer"]?.[0],
      futsalSMA?.["Best Goalkeeper"]?.[0],
    ]?.sort(
      (a, b) => parseInt(a?.order_position) - parseInt(b?.order_position),
    );

    dataFutsalSMAAnchor = dataFutsalSMAAnchor?.map((val) => val?.category);
    let dataFutsalSMPAnchor = [
      futsalSMP?.["Best Coach"]?.[0],
      futsalSMP?.["MVP"]?.[0],
      futsalSMP?.["Top Scorer"]?.[0],
      futsalSMP?.["Best Goalkeeper"]?.[0],
    ]?.sort(
      (a, b) => parseInt(a?.order_position) - parseInt(b?.order_position),
    );

    dataFutsalSMPAnchor = dataFutsalSMPAnchor?.map((val) => val?.category);
    const dataFutsalSMA = dataFutsalSMAAnchor?.map((val) => {
      return futsalSMA?.[val];
    });
    const dataFutsalSMP = dataFutsalSMPAnchor?.map((val) => {
      return futsalSMP?.[val];
    });

    const futsalKampus = hallOfFameData[FUTSAL_KAMPUS];
    const dataFutsalKampus = [
      futsalKampus?.["Best Coach"]?.[0],
      futsalKampus?.["MVP"]?.[0],
      futsalKampus?.["Top Scorer"]?.[0],
      futsalKampus?.["Best Goalkeeper"]?.[0],
    ]
      ?.sort(
        (a, b) => parseInt(a?.order_position) - parseInt(b?.order_position),
      )
      ?.map((val) => futsalKampus?.[val?.category]);

    return { dataFutsalSMA, dataFutsalSMP, dataFutsalKampus };
  };
  const collectionData = getOrder();

  const SectionWrapperCond = ({ cond, children }) => {
    if (!cond) {
      return (
        <ContainerWidth
          className={paddingContainerClassname}
          style={{ marginLeft: "auto", marginRight: "auto" }}
        >
          <SectionContainer backgroundColor={"transparent"}>
            {children}
          </SectionContainer>
        </ContainerWidth>
      );
    } else
      return (
        <Spacer
          marginLeft={"24px"}
          //  marginBottom={"32px"}
          className={paddingContainerClassname}
        >
          {children}
        </Spacer>
      );
  };

  const PlayerCategory = ({
    category,
    firstName,
    lastName,
    tagName,
    schoolName,
    schoolImg,
    playerImg = getStaticImg("/illustration/default-player.svg"),
    index,
    bgImg = getStaticImg("/illustration/swoosh-frame-carding.svg"),
    totalGoal,
    updatedAt,
    isOnGoing,
    onClick,
  }) => {
    const categoryImgLabel = String(category)?.toLowerCase()?.replace(" ", "-");
    const fontStyle = isMobileView
      ? {
          medium: "14px",
          small: "12px",
          large: "20px",
          extraSmall: "8px",
          normal: "10px",
          extraLarge: "24px",
        }
      : {
          medium: "17px",
          small: "13.5px",
          large: "24.9px",
          extraSmall: "9.8px",
          normal: "12.32px",
          extraLarge: "29.5px",
        };

    return (
      <PlayerContainer
        onClick={onClick}
        backgroundImage={bgImg}
        marginLeft={index === 1 ? "16px" : 0}
        marginRight={index > 0 ? "16px" : 0}
      >
        <Spacer marginLeft={"16px"}>
          <div id="player-label">
            <img
              src={getStaticImg(`/illustration/${categoryImgLabel}.svg`)}
              alt={categoryImgLabel}
              style={{ marginRight: 4, width: 24 }}
            />
            <CategoryTitle fontSize={fontStyle?.medium}>
              {category}
            </CategoryTitle>
            {category === "Top Scorer" && isOnGoing ? (
              <OnGoingTag>{"Ongoing"}</OnGoingTag>
            ) : (
              <></>
            )}
          </div>

          <Spacer marginTop={"16px"} />
          {/* Kalau first name-nya kosong tetep render satu baris kosong dengan
              ukuran font yang sama, biar tinggi barisnya persis sama kayak
              kartu yang ada first name-nya. */}
          <CategoryTitle fontSize={fontStyle?.medium}>
            {firstName || "\u00A0"}
          </CategoryTitle>
          <Spacer />
          <CategoryTitle fontSize={fontStyle?.large}>{lastName}</CategoryTitle>
          <Spacer marginTop={"8px"} />
          {/* verticalAlign "bottom" penting: sebagai inline-level box, tinggi
              baris ini ikut ke-baseline induknya. Kartu yang punya tag
              baseline-nya ngambil dari teks tag (di atas), kartu empty state
              ngambil dari bawah gambar, jadi kartu empty state kebagian
              leading tambahan dan tingginya beda sendiri. */}
          <div style={{ display: "inline-flex", verticalAlign: "bottom" }}>
            {tagName && (
              <div style={{ width: "20%" }}>
                {tagName && (
                  <TagPlayer>
                    <CategoryTitle fontSize={fontStyle?.small}>
                      {tagName}
                    </CategoryTitle>
                  </TagPlayer>
                )}
                {totalGoal && (
                  <>
                    <Spacer marginTop={"16px"} />
                    <CategoryTitle
                      fontSize={fontStyle?.normal}
                      fontWeight="normal"
                    >
                      {"Total Gol:"}
                    </CategoryTitle>
                    <Spacer />
                    <CategoryTitle
                      fontSize={fontStyle?.extraLarge}
                      fontWeight="bold"
                    >
                      {totalGoal}
                    </CategoryTitle>
                  </>
                )}
                {updatedAt && (
                  <div
                    style={{
                      lineHeight: 1,
                      marginTop: isMobileView ? "100%" : "90%",
                    }}
                  >
                    <CategoryTitle
                      fontSize={fontStyle?.extraSmall}
                      fontWeight="normal"
                    >
                      {"Updated:"}
                    </CategoryTitle>
                    <Spacer />
                    <CategoryTitle
                      fontSize={fontStyle?.extraSmall}
                      fontWeight="bold"
                    >
                      {updatedAt}
                    </CategoryTitle>
                  </div>
                )}
              </div>
            )}

            <div
              style={{
                width: tagName?.length ? "90%" : "100%",
                marginLeft: tagName?.length ? 0 : isMobileView ? 40 : 53,
              }}
            >
              {/* Tingginya sengaja ga dibedain lagi antara kartu yang punya tag
                  sama yang engga: bedanya bikin kartu empty state jadi lebih
                  tinggi dari kartu yang udah keisi di baris yang sama. Yang
                  dipake ukuran yang lebih gede, soalnya siluet default-nya
                  natively 132x167 -- kalau boxnya dikecilin, object-fit cover
                  ga nge-scale up lagi dan siluetnya jadi ngambang di atas
                  footer. */}
              <PlayerImg
                src={playerImg}
                alt="player"
                height={isMobileView ? "175px" : "222px"}
                // Tanpa translateY: gesernya bikin siluet nembus ke footer,
                // padahal mestinya berhenti pas di atas footer kayak foto
                // pemain yang udah keisi.
                transform={"rotate(0.0001deg)"}
              />
            </div>
          </div>
        </Spacer>

        <ContainerSchool>
          <img
            src={imgPath + schoolImg}
            alt="badge"
            style={{ width: 26, height: 21, objectFit: "contain" }}
          />
          <span>{schoolName}</span>
        </ContainerSchool>
      </PlayerContainer>
    );
  };

  // Sengaja ga disembunyiin walau datanya kosong: tiap kategori yang belum
  // ada pemenangnya udah dirender jadi kartu siluet (empty state) di bawah.
  // Satu blok kategori (judul + 4 kartu). Kategori yang belum ada pemenangnya
  // dirender jadi kartu siluet sebagai empty state.
  const renderCategory = ({
    title,
    data,
    activeCard,
    frame,
    placeholderSchool,
  }) => {
    const bgImg = getStaticImg(`/illustration/${frame}`);
    const goToStatistic = () =>
      navigate(
        `/${slug}/klasemen-pertandingan?activeCard=${activeCard}&tab=statistic`,
      );
    const clickPlayer = (category, title) => {
      analytics.sendEvent({ event: "best_player_click", category, title });
      goToStatistic();
    };
    const defaultCatOrder = [
      "Top Scorer",
      "MVP",
      "Best Goalkeeper",
      "Best Coach",
    ];

    // `data` udah diurutin ngikutin order_position dari API, jadi posisi kartu
    // yang kosong belum tentu sama dengan urutan default. Label kartu kosong
    // diambil dari kategori yang belum kepake, biar kategori yang udah ada
    // pemenangnya ga muncul lagi sebagai empty state.
    const filledCategories = (data ?? [])
      ?.map((dataVal) => dataVal?.[0]?.category)
      ?.filter(Boolean);
    const leftoverCategories = defaultCatOrder?.filter(
      (cat) => !filledCategories?.includes(cat),
    );
    const cardCategories = (data ?? [])?.map(
      (dataVal) => dataVal?.[0]?.category ?? leftoverCategories?.shift(),
    );

    return (
      <>
        <CategorySpacing>
          <CategoryTitle>{title}</CategoryTitle>
          <CategoryDetailBtn
            onClick={() => {
              analytics.sendEvent({ event: "detail_statistik_bestplayer" });
              goToStatistic();
            }}
          >
            <CategoryTitle fontWeight={"normal"} fontSize={"14px"}>
              {"Detail Statistik"}
            </CategoryTitle>
            <img
              src={getStaticImg("/illustration/sa-arrow-right.svg")}
              alt="arrow-right"
              style={{ marginLeft: 4 }}
            />
          </CategoryDetailBtn>
        </CategorySpacing>
        <PlayerWrapper>
          <Spacer marginTop={"16px"} />
          {data?.map((dataVal, i) => {
            const val = dataVal?.[0] ?? {};
            const isTopScorerCategory = val?.category === "Top Scorer";

            if (!Object.keys(val)?.length) {
              return (
                <PlayerCategory
                  key={i}
                  index={i}
                  bgImg={bgImg}
                  category={cardCategories[i]}
                  firstName={""}
                  lastName={
                    cardCategories[i] === "Best Coach" ? "Pelatih" : "Pemain"
                  }
                  tagName={null}
                  schoolName={placeholderSchool}
                  schoolImg={dataEvent?.key_visual}
                  onClick={() =>
                    clickPlayer(
                      cardCategories[i],
                      cardCategories[i] === "Best Coach" ? "Pelatih" : "Pemain",
                    )
                  }
                />
              );
            }

            return (
              <PlayerCategory
                key={i}
                index={i}
                bgImg={bgImg}
                category={val?.category}
                firstName={val?.first_name}
                lastName={val?.last_name}
                tagName={val?.tag_name}
                schoolName={val?.school_name}
                playerImg={imgPath + val?.player_image}
                totalGoal={isTopScorerCategory ? val?.goal_total : undefined}
                schoolImg={val?.school_logo}
                updatedAt={
                  isTopScorerCategory
                    ? moment(val?.updated_at).format("DD MMMM YYYY")
                    : null
                }
                isOnGoing={val?.is_ongoing}
                onClick={() =>
                  clickPlayer(
                    val?.category,
                    [val?.first_name, val?.last_name].filter(Boolean).join(" "),
                  )
                }
              />
            );
          })}
        </PlayerWrapper>
      </>
    );
  };

  return (
    <div id="hof">
      {soc ? (
        <>
          <div
            className=""
            style={{
              background: `url(${getStaticImg(
                "/illustration/sharp-swoosh.svg",
              )}) no-repeat left top, url(${getStaticImg(
                "/illustration/sharp-swoosh2.svg",
              )}) #1f2d3d no-repeat right bottom`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "left top, right bottom",
              width: "100vw",
              height: "auto",
            }}
          >
            <Spacer>
              <SectionWrapperCond cond={isMobileView}>
                <img
                  className="w-80 md:w-96 h-auto mt-[30%] md:mt-24"
                  src={getStaticImg("/illustration/hof-soc-title.svg")}
                  alt="hall-of-fame-title"
                />
                <>
                  <PlayerWrapper>
                    <Spacer marginTop={"36px"} />
                    {collectionData?.dataFutsalSMA?.map((dataVal, i) => {
                      const val = dataVal?.[0] ?? {};

                      const isTopScorerCategory =
                        val?.category === "Top Scorer";

                      if (!Object.keys(val)?.length) {
                        const defaultCatOrder = [
                          "Top Scorer",
                          "MVP",
                          "Best Goalkeeper",
                          "Best Coach",
                        ];
                        return (
                          <PlayerCategory
                            index={i}
                            bgImg={getStaticImg(
                              "/illustration/swoosh-frame-carding.svg",
                            )}
                            category={defaultCatOrder[i]}
                            firstName={""}
                            lastName={
                              defaultCatOrder[i] === "Best Coach"
                                ? "Pelatih"
                                : "Pemain"
                            }
                            tagName={null}
                            schoolName={"SMA/SMK"}
                            schoolImg={dataEvent?.key_visual}
                            onClick={() =>
                              navigate(
                                `/${slug}/klasemen-pertandingan?activeCard=futsalsmaGroup&tab=statistic`,
                              )
                            }
                          />
                        );
                      } else
                        return (
                          <PlayerCategory
                            index={i}
                            category={val?.category}
                            firstName={val?.first_name}
                            lastName={val?.last_name}
                            tagName={val?.tag_name}
                            schoolName={val?.school_name}
                            playerImg={imgPath + val?.player_image}
                            totalGoal={
                              isTopScorerCategory ? val?.goal_total : undefined
                            }
                            schoolImg={val?.school_logo}
                            updatedAt={
                              isTopScorerCategory
                                ? moment(val?.updated_at).format("DD MMMM YYYY")
                                : null
                            }
                            isOnGoing={val?.is_ongoing}
                            onClick={() =>
                              navigate(
                                `/${slug}/klasemen-pertandingan?activeCard=futsalsmaGroup&tab=statistic`,
                              )
                            }
                          />
                        );
                    })}
                  </PlayerWrapper>
                  {shouldUseSOC2025 ? (
                    <div className="flex justify-center pr-[24px] mt-12 w-full">
                      <button
                        className="w-[327px] h-[44px] bg-[#00BCF1] rounded-[40px] text-white border-transparent font-bold"
                        onClick={() =>
                          navigate(
                            `/soc/klasemen-pertandingan?activeCard=futsalsmaGroup&tab=statistic`,
                          )
                        }
                      >
                        Detail Statistik
                      </button>
                    </div>
                  ) : (
                    <></>
                  )}

                  <Spacer marginBottom={"32px"} />
                </>
              </SectionWrapperCond>
            </Spacer>
          </div>
        </>
      ) : (
        <HallOfFameContainer>
          {/* {!isMobileView && <GradientTop />} */}
          {/* <TopSwoosh /> */}
          <Spacer>
            <SectionWrapperCond cond={isMobileView}>
              <HallOfFameTitle
                src={getStaticImg("/illustration/hall-of-fame-title.svg")}
                alt="hall-of-fame-title"
              />
              {renderCategory({
                title: FUTSAL_SMA,
                data: collectionData?.dataFutsalSMA,
                activeCard: "futsalsmaGroup",
                frame: "swoosh-frame-carding.svg",
                placeholderSchool: "SMA/SMK",
              })}
              <Spacer marginBottom={isMobileView ? "32px" : "64px"} />
              {renderCategory({
                title: FUTSAL_SMP,
                data: collectionData?.dataFutsalSMP,
                activeCard: "futsalsmpGroup",
                frame: "swoosh-frame-carding-green.svg",
                placeholderSchool: "SMP",
              })}
              <Spacer marginBottom={isMobileView ? "32px" : "64px"} />
              {renderCategory({
                // Key API tetap "Futsal Kampus"; label tampilannya ngikutin
                // carousel klasemen ("Perguruan Tinggi").
                title: "Futsal Perguruan Tinggi",
                data: collectionData?.dataFutsalKampus,
                activeCard: "futsalkuliahGroup",
                frame: "swoosh-frame-carding-orange.svg",
                placeholderSchool: "Perguruan Tinggi",
              })}
            </SectionWrapperCond>
          </Spacer>
        </HallOfFameContainer>
      )}
    </div>
  );
};

export default HallOfFameCard;
